import { PrismicNextImage } from "@prismicio/next";
import { PrismicLink, PrismicRichText } from "@prismicio/react";
import React from "react";
import * as style from "./index.module.scss";
import { IoArrowForward } from "react-icons/io5";
import { Headset } from "react-ionicons";

const HeroSection = ({ data }) => {
  return (
    <div
      className={`d-flex flex-column justify-content-center align-items-center w-100 ${style.hero_wrapper} subtitle section_wrapper section_color`}
    >
      <div
        className="d-flex flex-column justify-content-center align-items-center text-center"
        style={{ maxWidth: 842 }}
      >
        <div className={style.subtitle}>{data.subtitle}</div>
        <div className={style.title}>
          <PrismicRichText field={data.title} />
        </div>
        <div className={style.description}>
          <PrismicRichText field={data.description} />
        </div>
      </div>

      <div className={style.button_container}>
        {/* <PrismicLink
          target="_self"
          field={data.primary_button}
          className={`btn btn-mob-full-w btn-primary ${style.primary_button}`}
        >
          {data.primary_button_label} <IoArrowForward size="18px" />
        </PrismicLink> */}

        <PrismicLink
          target="_self"
          field={data.secondary_button}
          className={`btn btn-mob-full-w  btn-outline-dark ${style.secondary_button}`}
        >
          <Headset size="18px" color="#1570EF" /> {data.secondary_button_label}
        </PrismicLink>
      </div>

      <PrismicNextImage
        field={data.cover_image}
        fallbackAlt=""
        style={{ maxWidth: 688 }}
      />
    </div>
  );
};

export default HeroSection;
